import React, { useEffect, FC } from "react";
import { Table, Button, Tooltip, message } from "antd";
import { YHModal } from "@/components/YHModal";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { useChargebackDetailsModel, IMaterialDetailModel } from "./chargebackDetailsModels";
import { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { formatIntPoint, formatNum } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";
enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const MaterialModal: FC<RouterParamType> = ({ id, mode }) => {
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const {
        materialModel: visible,
        setMaterialModel,
        workMaterialDataSource,
        addDataMaterialSource,
        workMaterialloadData,
        resetWorkMaterialloadData,
        setSearchWorkMaterialData,
        setAddDataMaterialSource,
        setWorkMaterialDataSource,
        transformsToPoMaterialDetailList
    } = useChargebackDetailsModel();
    const onOk = () => {
        transformsToPoMaterialDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setMaterialModel(false);
        setAddDataMaterialSource([]);
        setSearchWorkMaterialData({})
    };
    useEffect(() => {
        visible && workMaterialloadData()
    }, [visible])

    const column = (optype: number) => [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编号',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件名称',
            width: 140,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '可用库存',
            width: 100,
            dataIndex: 'inventoryNum',
        }, {
            title: '库房',
            width: 140,
            dataIndex: 'warehouseName',
        },
        {
            title: '使用数量',
            width: 100,
            dataIndex: 'num',
            editable: true,
        },
        {
            title: '单价',
            width: 100,
            dataIndex: 'price',
        },
        {
            title: '总计',
            width: 100,
            dataIndex: 'materialAmount',
        },
        {
            title: '单项优惠金额',
            width: 140,
            dataIndex: 'decreaseAmount'
        },
        {
            title: '原单折扣',
            width: 100,
            dataIndex: 'discountRate',
            render: (text: string) => text + "%"
        },
        {
            title: '原单总计',
            width: 100,
            dataIndex: 'receivableAmount',
        },
        {
            title: '货位',
            width: 100,
            dataIndex: 'shelfCode',
        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) => optype === OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    txt="添加"
                    click={() => add(record)}
                    disabled={!!addDataMaterialSource.find(item => item.id === record.id)
                        || record.availableStock === 0}
                />
            ) : (
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => remove(record)}
                />
            )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType === OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })

    const roleColumns = (optType: number) => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "orderReturn", "roleCodes": roles };
        return getRoleColumns("orderReturn", "新增商品", newSelectColumns(optType), params);
    };

    const add = async (record: IMaterialDetailModel) => {
        setAddDataMaterialSource(origin => [...origin, record])
    }
    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataMaterialSource.filter(item => item.id !== record.id)
        setAddDataMaterialSource(filterAddDataSource)
    }
    const notHandleSave = (row: IMaterialDetailModel) => {
        let { num, oldNum, price } = row;
        num = +formatIntPoint(num);
        price = +formatNum(price);
        if (num > oldNum) {
            num = oldNum;
            message.warning('修改数量时，不能大于原单的数量');
        }
        let newRow = {
            ...row,
            num,
            materialAmount: +formatNum(num * price)
        }
        const index = workMaterialDataSource.findIndex((item) => row.id === item.id);
        const item = workMaterialDataSource[index];
        workMaterialDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkMaterialDataSource([...workMaterialDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let { num, oldNum, price } = row;
        num = +formatIntPoint(num);
        price = +formatNum(price);
        if (num > oldNum) {
            num = oldNum;
            message.warning('修改数量时，不能大于原单的数量');
        }
        let newRow = {
            ...row,
            num,
            materialAmount: +formatNum(num * price)
        }
        const index = addDataMaterialSource.findIndex((item) => row.id === item.id);
        const item = addDataMaterialSource[index];
        addDataMaterialSource.splice(index, 1, { ...item, ...newRow });
        setAddDataMaterialSource([...addDataMaterialSource])
    }

    const rightChildren = <div className="flex">
        <Button onClick={() => resetWorkMaterialloadData()} shape="round">重置</Button>
    </div>

    return <YHModal
        visible={visible}
        onOk={onOk}
        onCancel={onCancel}
        title="工单管理-选择配件"
        width={'70%'}
        bodyHeight={730}
        showFooter={true}
    >
        <YhBox title="待选配件列表" rightChildren={rightChildren} style={{ marginBottom: "5px" }}>
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id as string}
                columns={roleColumns(OPT_TYPE.ADD) as ColumnsType<IMaterialDetailModel>}
                dataSource={workMaterialDataSource}
                pagination={false}
                components={components}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选配件列表">
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id as string}
                columns={roleColumns(OPT_TYPE.REMOVE) as ColumnsType<IMaterialDetailModel>}
                dataSource={addDataMaterialSource}
                pagination={false}
                components={components}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}